import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
 
} from "../../service/casino";
import toast from "react-hot-toast";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import { CARD_ARRAY } from "../casino/CasinoGeneric";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function OneDayDT() {
  const GAME_ID = "UNI_1_DAY_DRAGON_TIGER";
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [selected, setSelected] = React.useState("DRAGON");
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
   useEffect(() => {
     roundIdRef.current = odds?.roundId;
     setTimer(odds?.seconds);
     let interval = setInterval(() => {
       if (odds?.status == "SUSPEND" || timer <= 0) {
         setTimer(0);
       } else {
         setTimer((prev) => prev - 1);
       }
     }, 1000);

     return () => {
       clearInterval(interval);
     };
   }, [odds?.roundId]);
  
  
   React.useEffect(() => {
     getOdds();
     getLastResult();
     let interval = setInterval(() => {
       getOdds();
     }, 800);
     let interval2 = setInterval(() => {
       getLastResult();
     }, 5000);
     let interval3 = setInterval(() => {
       getExposure();
     }, 2000);
     return () => {
       clearInterval(interval);
       clearInterval(interval2);
       clearInterval(interval3);
     };
   }, []);
   useEffect(() => {
     roundIdRef.current = odds?.roundId;
     setTimer(odds?.seconds);
     let interval = setInterval(() => {
       if (odds?.status == "SUSPEND" || timer <= 0) {
         setTimer(0);
       } else {
         setTimer((prev) => prev - 1);
       }
     }, 1000);

     // Add interval for time condition check
     let timeCheckInterval = setInterval(checkTimeCondition, 100);

     return () => {
       clearInterval(interval);
       clearInterval(timeCheckInterval);
     };
   }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
   return (
     <app-dragon-tiger-1-day _nghost-ng-c1914738111="">
       <div
         _ngcontent-ng-c1914738111=""
         style={{ overflowY: "scroll", height: "min-content" }}
       >
         <div _ngcontent-ng-c1914738111="">
           <app-video-player
             _ngcontent-ng-c1914738111=""
             _nghost-ng-c595356512=""
           >
             <div _ngcontent-ng-c595356512="" className="videoPlayer">
               <video
                 _ngcontent-ng-c595356512=""
                 id="remoteVideo"
                 width="100%"
                 height="100%"
                 autoplay=""
                 playsinline=""
                 muted=""
                 style={{
                   background:
                     "black 50% / 48% 75% no-repeat  url(https://casino.queenexch.com/assets/loader.gif)",
                 }}
               ></video>

               <div _ngcontent-ng-c595356512="" className="video-overlay">
                 <div _ngcontent-ng-c595356512="">
                   <div
                     _ngcontent-ng-c595356512=""
                     className="round-id text-white"
                   >
                     RID: {odds?.roundId}
                   </div>
                 </div>
               </div>
               {showWinnerOverlay && (
                 <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                   <div
                     _ngcontent-ng-c595356512=""
                     className="mini-result-new active"
                   >
                     <span _ngcontent-ng-c595356512="">
                       {" "}
                       {odds?.roundWinner} win{" "}
                     </span>
                     {/**/}
                   </div>
                   <span
                     _ngcontent-ng-c595356512=""
                     style={{ position: "absolute" }}
                   >
                     <canvas
                       _ngcontent-ng-c595356512=""
                       width="100vw"
                       height="100vh"
                     />
                   </span>
                   {/**/}
                 </div>
               )}

               <div _ngcontent-ng-c595356512="" className="timer-overlay">
                 <GenericCasinoTimer
                   time={odds?.seconds}
                   status={odds?.status}
                 />
               </div>
             </div>

             <div
               _ngcontent-ng-c595356512=""
               id="rulesModal"
               tabIndex={-1}
               aria-labelledby="exampleModalLabelaexampleModalLabela"
               aria-hidden="true"
               className="modal fade"
             >
               <div
                 _ngcontent-ng-c595356512=""
                 className="modal-dialog rules-wrap"
               >
                 <div
                   _ngcontent-ng-c595356512=""
                   role="document"
                   id="rulesList___BV_modal_content_"
                   tabIndex={-1}
                   className="modal-content rules-content"
                 >
                   <header
                     _ngcontent-ng-c595356512=""
                     id="rulesList___BV_modal_header_"
                     className="rules-wrap"
                   >
                     <a _ngcontent-ng-c595356512="">
                       <h3
                         _ngcontent-ng-c595356512=""
                         id="rulesList___BV_modal_title_"
                         data-bs-toggle="modal"
                         data-bs-target="#rulesModal"
                         className="modal-title"
                       >
                         {" "}
                         Rules
                       </h3>
                     </a>
                     <button
                       _ngcontent-ng-c595356512=""
                       type="button"
                       data-bs-dismiss="modal"
                       aria-label="Close"
                       className="close"
                     >
                       ×
                     </button>
                   </header>
                   <div
                     _ngcontent-ng-c595356512=""
                     id="rulesList___BV_modal_body_"
                     className="modal-body"
                   >
                     <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                   </div>
                   <div _ngcontent-ng-c595356512="">
                     <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                       <li _ngcontent-ng-c595356512="">
                         <a
                           _ngcontent-ng-c595356512=""
                           data-bs-dismiss="modal"
                           aria-label="Close"
                           className="btnok"
                         >
                           OK
                         </a>
                       </li>
                     </ul>
                   </div>
                 </div>
               </div>
             </div>
           </app-video-player>
         </div>
         <div
           _ngcontent-ng-c1914738111=""
           id="marketScroll"
           style={{ overflowY: "auto" }}
           className="overflow-auto"
         >
           <div _ngcontent-ng-c1914738111="">
             <ol
               style={{
                 position: "relative",
                 color: "black",
                 width: "100%",
                 height: "100%",
                 justifyContent: "center",
               }}
               _ngcontent-ng-c1914738111=""
               className="circle"
             >
               <div
                 _ngcontent-ng-c1914738111=""
                 className="d-flex justify-content-between dra-tig-title "
               >
                 <span _ngcontent-ng-c1914738111=""> DRAGON </span>
                 <span _ngcontent-ng-c1914738111=""> TIGER </span>
               </div>
               <li
                 _ngcontent-ng-c1914738111=""
                 className="d-flex justify-content-between"
               >
                 <div _ngcontent-ng-c1914738111="">
                   <div _ngcontent-ng-c1914738111="" className="d-flex">
                     <div
                       _ngcontent-ng-c1914738111=""
                       className={`back backbox p-3 ps-4 pe-4 d-flex align-items-center flex-column ${
                         odds?.status == "SUSPEND" ? "suspended" : ""
                       }`}
                     >
                       <span _ngcontent-ng-c1914738111="" className="f-16">
                         {getOddsByRunner(odds, "DRAGON")}
                       </span>
                       <span _ngcontent-ng-c1914738111="">
                         {getOddsByRunner(odds, "DRAGON", true)?.backSize1}
                       </span>
                     </div>
                     <div
                       _ngcontent-ng-c1914738111=""
                       className={`lay laybox p-3 ps-4 pe-4 d-flex align-items-center flex-column ${
                         odds?.status == "SUSPEND" ? "suspended" : ""
                       }`}
                     >
                       <span _ngcontent-ng-c1914738111="" className="f-16">
                         {getOddsByRunner(odds, "DRAGON", true)?.lay1}
                       </span>
                       <span _ngcontent-ng-c1914738111="">
                         {getOddsByRunner(odds, "DRAGON", true)?.laySize1}
                       </span>
                     </div>
                   </div>
                 </div>
                 <div _ngcontent-ng-c1914738111="">
                   <div _ngcontent-ng-c1914738111="" className="d-flex">
                     <div
                       _ngcontent-ng-c1914738111=""
                       className={`back backbox p-3 ps-4 pe-4 d-flex align-items-center flex-column ${
                         odds?.status == "SUSPEND" ? "suspended" : ""
                       }`}
                     >
                       <span _ngcontent-ng-c1914738111="" className="f-16">
                         {getOddsByRunner(odds, "TIGER")}
                       </span>
                       <span _ngcontent-ng-c1914738111="">
                         {getOddsByRunner(odds, "TIGER", true)?.backSize1}
                       </span>
                     </div>
                     <div
                       _ngcontent-ng-c1914738111=""
                       className={`lay laybox p-3 ps-4 pe-4 d-flex align-items-center flex-column ${
                         odds?.status == "SUSPEND" ? "suspended" : ""
                       }`}
                     >
                       <span _ngcontent-ng-c1914738111="" className="f-16">
                         {getOddsByRunner(odds, "TIGER", true)?.lay1}
                       </span>
                       <span _ngcontent-ng-c1914738111="">
                         {getOddsByRunner(odds, "TIGER", true)?.laySize1}
                       </span>
                     </div>
                   </div>
                 </div>
               </li>
             </ol>

             <div
               _ngcontent-ng-c1914738111=""
               className="container-fluid container-fluid-5 mt-1"
             >
               <div _ngcontent-ng-c1914738111="">
                 <div
                   _ngcontent-ng-c1914738111=""
                   className="row row5 light-bg"
                 >
                   <div
                     _ngcontent-ng-c1914738111=""
                     className="col-sm-12 col-xs-12"
                   >
                     <button
                       _ngcontent-ng-c1914738111=""
                       className={`btn-theme mt-1 text-uppercase d-flex justify-content-between align-items-center ps-5 pe-5 f-16 ${
                         odds?.status == "SUSPEND" ? "suspended" : ""
                       }`}
                     >
                       {" "}
                       PAIR (TIE){" "}
                       <b _ngcontent-ng-c1914738111="">
                         {getOddsByRunner(odds, "PAIR (TIE)")}
                       </b>
                     </button>
                     <p _ngcontent-ng-c1914738111="" className="mb-0">
                       <span
                         _ngcontent-ng-c1914738111=""
                         className="profitLoss-font"
                       >
                         {getUniversalCasinoPlExposureByRunner(
                           exposure,
                           "PAIR (TIE)"
                         )}
                       </span>
                     </p>
                   </div>
                 </div>
                 <div
                   _ngcontent-ng-c1914738111=""
                   className="row row5 light-bg pt-0"
                 >
                   <div
                     _ngcontent-ng-c1914738111=""
                     className="col-12 text-right"
                   >
                     <p
                       _ngcontent-ng-c1914738111=""
                       className="mb-0 min-max h-18"
                     >
                       {" "}
                       Min:100 Max:100000{" "}
                     </p>
                   </div>
                 </div>
               </div>
             </div>
             <ul _ngcontent-ng-c1914738111="" className="nav nav-tabs">
               <li
                 _ngcontent-ng-c1914738111=""
                 onClick={() => setSelected("DRAGON")}
                 className={`nav-item col ${
                   selected == "DRAGON" ? "activeTab" : ""
                 }`}
               >
                 <a
                   _ngcontent-ng-c1914738111=""
                   data-toggle="tab"
                   className="nav-link game"
                 >
                   Dragon
                 </a>
               </li>
               <li
                 onClick={() => setSelected("TIGER")}
                 _ngcontent-ng-c1914738111=""
                 className={`nav-item col ${
                   selected == "TIGER" ? "activeTab" : ""
                 }`}
               >
                 <a
                   _ngcontent-ng-c1914738111=""
                   data-toggle="tab"
                   className="nav-link match"
                 >
                   Tiger
                 </a>
               </li>
             </ul>
             <div
               _ngcontent-ng-c1914738111=""
               className="container-fluid container-fluid-5 mt-2"
             >
               <div _ngcontent-ng-c1914738111="" className="row row5">
                 <div _ngcontent-ng-c1914738111="" className="col-6">
                   <div _ngcontent-ng-c1914738111="">
                     <div
                       _ngcontent-ng-c1914738111=""
                       className="row row5 light-bg"
                     >
                       {["EVEN", "ODD"].map((item) => (
                         <div _ngcontent-ng-c1914738111="" className="col-6">
                           <p
                             _ngcontent-ng-c1914738111=""
                             className="d-block mb-0 text-center h-18 f-16"
                           >
                             <b _ngcontent-ng-c1914738111="">
                               {getOddsByRunner(odds, selected + " " + item)}
                             </b>
                           </p>
                           <button
                             _ngcontent-ng-c1914738111=""
                             className={`btn-theme mt-1 text-uppercase ${
                               odds?.status == "SUSPEND" ? "suspended" : ""
                             }`}
                           >
                             {" "}
                             {item}{" "}
                           </button>
                           <p _ngcontent-ng-c1914738111="" className="mb-0">
                             <span
                               _ngcontent-ng-c1914738111=""
                               className="profitLoss-font"
                             >
                               {getUniversalCasinoPlExposureByRunner(
                                 exposure,
                                 item == "[_{" ? "RED" : "BLACK"
                               )}
                             </span>
                           </p>
                         </div>
                       ))}
                     </div>
                     <div
                       _ngcontent-ng-c1914738111=""
                       className="row row5 light-bg"
                     >
                       <div
                         _ngcontent-ng-c1914738111=""
                         className="col-12 text-right"
                       >
                         <p
                           _ngcontent-ng-c1914738111=""
                           className="mb-0 min-max h-18"
                         >
                           {" "}
                           Min:100 Max:100000{" "}
                         </p>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div _ngcontent-ng-c1914738111="" className="col-6">
                   <div _ngcontent-ng-c1914738111="">
                     <div _ngcontent-ng-c1914738111="" className="row light-bg">
                       {["[_{", "]_}"].map((item) => (
                         <>
                           <div _ngcontent-ng-c1914738111="" className="col-6">
                             <p
                               _ngcontent-ng-c1914738111=""
                               className="d-block mb-0 text-center h-18 f-16"
                             >
                               <b _ngcontent-ng-c1914738111="">
                                 {getOddsByRunner(
                                   odds,
                                   selected + " " + item == "[_{"
                                     ? "RED"
                                     : "BLACK"
                                 )}
                               </b>
                             </p>
                             <button
                               _ngcontent-ng-c1914738111=""
                               className={`btn-theme mt-1 text-uppercase ${
                                 odds?.status == "SUSPEND" ? "suspended" : ""
                               }`}
                             >
                               <span
                                 _ngcontent-ng-c1914738111=""
                                 class="card-icon"
                               >
                                 <span
                                   _ngcontent-ng-c1914738111=""
                                   class={`card-${
                                     item == "[_{" ? "red" : "black"
                                   }`}
                                 >
                                   {item?.split("_")[0]}
                                 </span>
                               </span>
                               <span
                                 _ngcontent-ng-c1914738111=""
                                 class="card-icon"
                               >
                                 <span
                                   _ngcontent-ng-c1914738111=""
                                   class={`card-${
                                     item == "[_{" ? "red" : "black"
                                   }`}
                                 >
                                   {item?.split("_")[1]}
                                 </span>
                               </span>
                             </button>
                             <p _ngcontent-ng-c1914738111="" className="mb-0">
                               <span
                                 _ngcontent-ng-c1914738111=""
                                 className="profitLoss-font"
                               >
                                 {getUniversalCasinoPlExposureByRunner(
                                   exposure,
                                   item == "[_{" ? "RED" : "BLACK"
                                 )}
                               </span>
                             </p>
                           </div>
                         </>
                       ))}
                     </div>

                     <div _ngcontent-ng-c1914738111="" className="row light-bg">
                       <div
                         _ngcontent-ng-c1914738111=""
                         className="col-12 text-right"
                       >
                         <p
                           _ngcontent-ng-c1914738111=""
                           className="mb-0 min-max h-18"
                         >
                           {" "}
                           Min:100 Max:100000{" "}
                         </p>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div
               _ngcontent-ng-c1914738111=""
               className="light-bg container-fluid mt-2"
             >
               <div _ngcontent-ng-c1914738111="" className="row row5">
                 <div
                   _ngcontent-ng-c1914738111=""
                   className="col-5 me-4 text-center h-18 f-16"
                 >
                   <b _ngcontent-ng-c1914738111="" className="float-start">
                     {selected} CARD
                   </b>
                 </div>
                 <div
                   _ngcontent-ng-c1914738111=""
                   className="col-6 d-flex text-center justify-content-between h-18 f-16"
                 >
                   <b _ngcontent-ng-c1914738111="">12</b>
                   <div
                     _ngcontent-ng-c1914738111=""
                     className="info-block float-right"
                   >
                     <i
                       _ngcontent-ng-c1914738111=""
                       data-bs-toggle="dropdown"
                       aria-expanded="false"
                       className="fas fa-info-circle float-right"
                       data-bs-target="#collapse129210203184608"
                       id="#collapse129210203184608"
                     />
                     <ul
                       _ngcontent-ng-c1914738111=""
                       className="dropdown-menu"
                       aria-labelledby="collapse129210203184608"
                     >
                       <span _ngcontent-ng-c1914738111="">Min: 100 </span>
                       <span _ngcontent-ng-c1914738111="">Max: 20000 </span>
                     </ul>
                   </div>
                 </div>
               </div>
               <div _ngcontent-ng-c1914738111="" className="row row5 mt-2">
                 <div
                   _ngcontent-ng-c1914738111=""
                   className="col-12 text-center"
                 >
                   {CARD_ARRAY?.map((card) => (
                     <div
                       _ngcontent-ng-c1914738111=""
                       className="mr-2 dt-card d-inline-block"
                     >
                       <div
                         _ngcontent-ng-c1914738111=""
                         className={
                           odds?.status == "SUSPEND" ? "suspended" : ""
                         }
                       >
                         <img
                           _ngcontent-ng-c1914738111=""
                           src={`https://casino.queenexch.com/assets/lucky7_cards/${card}.png`}
                         />
                       </div>
                       <div
                         _ngcontent-ng-c1914738111=""
                         className="ubook text-center m-t-5 text-success h-18"
                         style={{ width: 40 }}
                       >
                         {getUniversalCasinoPlExposureByRunner(exposure, card)}
                       </div>
                     </div>
                   ))}
                 </div>
               </div>
             </div>
           </div>

           <GetUniversalLastTenResult lastResult={lastResult} />
         </div>
       </div>
     </app-dragon-tiger-1-day>
   );
}
